function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

$(function(){


	var $imgs = $('img[x-src]');





	if ($(window).width() > 700) {


		$imgs.each(function(){


			var src = $(this).attr('x-src');


			$(this).attr('src', src);	


		});


	}





	window.resizeFrame = function(){


		parent.postMessage("resize:"+$('body').height(), "*");


	};


	window.resizeFrame();


	var debresize = debounce(function(){


		window.resizeFrame();


	},80);





	$(window).on('resize', debresize);


});
// Quint
// 
mina.easeInQuint = function (n) {
	return Math.pow( n, 5 );
};
mina.easeOutQuint = function(n) {
	return Math.pow( n - 1, 5 ) + 1;
};
mina.easeInOutQuint = function (n) {
	if ( ( n *= 2 ) < 1) return 0.5 * Math.pow( n, 5 );
	return 0.5 * ( Math.pow( n - 2, 5 ) + 2 );
};

mina.easeInCubic = function (n) {
	return Math.pow( n, 3 );
};
mina.easeOutCubic = function(n) {
	return Math.pow( n - 1, 3 ) + 1;
};
mina.easeInOutCubic = function (n) {
	if ( ( n *= 2 ) < 1 ) return 0.5 * Math.pow( n, 3 );
	return 0.5 * ( Math.pow( n - 2, 3 ) + 2 );
};

$(function(){
	var $visuals = $('.tricks__visual');
	var $vectors = $('.tricks__visuals__vectors');
	var $svg = $('#snap');

	var h = $vectors.height();
	var w = $vectors.width();

	$svg.attr('height', h);
	$svg.attr('width', w);
	

	

	var vectorsIn = false;
	var visuals = [];

	function calcVisualsPos(){
		var p2 = Math.round(w*0.2);
		var p3 = Math.round(w*0.3);
		var p4 = Math.round(w*0.4);
		var p5 = Math.round(w*0.5);
		var p6 = Math.round(w*0.6);
		var p8 = Math.round(w*0.8);
		var p9 = Math.round(w*0.9);
		var p95 = Math.round(w*0.95);
		visuals = [
			{
				vectors: {
					purple: [0,0, 0,50, p8,h, 0,h, 0,0],
					yellow: [0,0, 0,50, p8,h, p8,h, p6,0],
					white: [p6,0, w,0, w,h, p8,h],
					white2: [0,0, 0,0, 0,h, 0,h],
				}
			},
			{
				vectors: {
					purple: [w,0, w,0 , p4-50,h, p4-50,h, p2,0],
					yellow: [w,0, w,0,  p4-50,h, w,h, w,0],
					white: [w,0, w,0, w,h, w,h],
					white2: [0,0, p2,0, p4-50,h, 0,h],
				}
			},
			{
				vectors: {
					purple: [0,0, 0,10, p95,h, 0,h, 0,0],
					yellow: [0,0, 0,10, p95,h, p95,h, p6,0],
					white: [p6,0, w,0, w,h, p95,h],
					white2: [0,0, 0,0, 0,h, 0,h],
				}
			},
			{
				vectors: {
					purple: [p2,0, w,0, p5,h, p5,h, p2,0],
					yellow: [w,0, w,0, p5,h, w,h, w,0],
					white: [w,0, w,0, w,h, w,h],
					white2: [0,0, p2,0, p5,h, 0,h],
				}
			},
			{
				vectors: {
					purple: [p5,0, p5,0, p3,h, 0,h, 0,0],
					yellow: [p5,0, p5,0, p3,h, p3,h, w,0],
					white: [w,0, w,0, w,h, p3,h],
					white2: [0,0, 0,0, 0,h, 0,h],
				}
			}
		];
	}
	calcVisualsPos();

	var s = Snap('#snap');
	var purple = s.polygon(visuals[2].vectors.purple).attr({ fill: "#e60079", "fill-opacity": 0.75 });
	var yellow = s.polygon(visuals[2].vectors.yellow).attr({ fill: "#e3f56d", "fill-opacity": 0.75 });
	var white = s.polygon(visuals[2].vectors.white).attr({ fill: "#ffffff", "fill-opacity": 0.90  });
	var white2 = s.polygon(visuals[2].vectors.white2).attr({ fill: "#ffffff", "fill-opacity": 0.90  });

	// var h = $('');

	var activeSlide = 0;

	function setSlide(index) {
		if (index !== activeSlide) {
			$($visuals[activeSlide]).addClass('tricks__visual__out').removeClass('tricks__visual__active');
		}

		var $nsl = $($visuals[index]);
		if ($nsl.length) {
			$nsl.addClass('tricks__visual__active');

			setTimeout(function(){
				$visuals.removeClass('tricks__visual__out');
			},400);
		}

		var animationSpeed = 1000;

		// if (vectorsIn === false) {
			// animationSpeed = 0;
			vectorsIn = true;
		// }

		purple.animate({
			"points": visuals[index].vectors.purple
		},animationSpeed, mina.easeOutCubic);
		yellow.animate({
			"points": visuals[index].vectors.yellow
		},animationSpeed, mina.easeOutCubic);
		white.animate({
			"points": visuals[index].vectors.white
		},animationSpeed, mina.easeOutCubic);
		white2.animate({
			"points": visuals[index].vectors.white2
		},animationSpeed, mina.easeOutCubic);


		activeSlide = index;
	}

	setSlide(0);

	var nslide = 0;
	setInterval(function(){
		if ($('.tricks__visual').css('display') !== 'none') {
			nslide++;
			if (nslide === $visuals.length) {
				nslide = 0;
			}
			// nslide = 4;
			setSlide(nslide);
			// setSlide(3);
		}
	},5 * 1000);

	var db = debounce(function(){
		h = $vectors.height();
		w = $vectors.width();
		calcVisualsPos();

		$svg.attr('height', h);
		$svg.attr('width', w);
		vectorsIn = true;
	},100);
	$(window).on('resize', db);
});

var postStrings = {
	'en': 'Check out my PLAY LOUD style. What’s yours? Bring the noise. #CHOOSETRICKS. www.puma.com/playloud-eu ',
	'fr': 'Découvre mon style PLAY LOUD. Montre-nous le tien et fais du bruit. #CHOOSETRICKS. www.puma.com/playloud-eu',
	'de': 'Schau dir meinen PLAY LOUD style an. Wie sieht deiner aus? Zeig was du kannst. #CHOOSETRICKS. www.puma.com/playloud-eu',
	'it': 'Questo è il mio stile PLAY LOUD. Mostrami il tuo. #CHOOSETRICKS. www.puma.com/playloud-eu',
	'es': 'Este es mi estilo PLAY LOUD. ¿Cual es el tuyo? #CHOOSETRICKS. www.puma.com/playloud-eu'
};


$(function(){
	localStorage.clear();

	function track(opts){
		// console.log(opts);
		ga('send', 'event', opts.cat, opts.act, parseInt(opts.val) | '__');
	}

	var getjsondata = $.ajax({url: '/config.php?getjsondata=1'});
	var jsondata;
	getjsondata.success(function(e){
		jsondata = e;
	});


	$('a[href="#"]').on('click', function(){
		return false;
	});

	var ovclasses = 'posting doneposting wait twitterpin fbpin';

	$.ajaxSetup({ cache: true });
	$.getScript('//connect.facebook.net/en_US/sdk.js', function(){
		FB.init({
			appId: '1060879537283913',
			version: 'v2.6' // or v2.0, v2.1, v2.2, v2.3
		});

		shareFacebook = function(){
			$('.tricks__social').removeClass(ovclasses).addClass('fbpin');
		};

	});
	var postImage = function(token) {
		console.log("posting");
		$('.tricks__social').removeClass(ovclasses).addClass('posting');
		$.ajax({
			type: "POST",
			url: "https://graph.facebook.com/me/photos",
			data: {
				// url: "http://brendan-mullins.com/img/img.jpg",
				url: 'http://139.59.204.5/assets/web/g_img/'+selected.finalimage,
				message: $('#fbtext').val(),
				access_token: token,
				format: "json"
			},
			success: function(data){
				$('.tricks__social').removeClass(ovclasses).addClass('doneposting');
				setTimeout(function(){
					$('.tricks__social').removeClass(ovclasses);
				}, 1500);

				track({
					cat: 'Share',
					act: 'Facebook'
				});
			}
		});
	};


	var shareFacebook = function(){
		$('.tricks__social').removeClass(ovclasses);
	};


	var cb;

	var shareTwitter = function(skip, text){
		cb = new Codebird();
		cb.setConsumerKey("HuiKR9LsHvdIiqDmEGREMbcSq", "MCDlzZnaxl8LEnftNRxNeeXULzNKKEy3qtoa0Ptq6G43hrPCtS");

		if(skip !== false && (skip === true || localStorage.length)){

			cb.setToken(localStorage.tw_token, localStorage.tw_token_secret);

			$('.tricks__social').removeClass(ovclasses).addClass('posting');

			var img = 'assets/web/g_img/'+selected.finalimage;
			// var img = 'http://brendan-mullins.com/img/img.jpg';
			$.ajax({
				type: "POST",
				url: "/base64.php",
				data: {
					img: img
				},
				success: function(data) {

					var params = {"media": data.base64};
					cb.__call(
					    "media_upload",
					    params,
					    function (reply, rate, err) {
					        // you get a media id back:

					        cb.__call(
							    "statuses_update",
							    {
							        "media_ids": reply.media_id_string,
							        "status": $('#tweettext').val()
							    },
							    function (reply, rate, err) {
							        $('.tricks__social').removeClass(ovclasses).addClass('doneposting');
									setTimeout(function(){
										$('.tricks__social').removeClass(ovclasses);
									}, 1500);

									if (typeof reply.errors !== 'undefined') {
										shareTwitter(false);
										$('.tricks__social').removeClass(ovclasses);
									}else{
										track({
											cat: 'Share',
											act: 'twitter'
										});
										localStorage.clear();
									}
							    }
							);
					    }
					);
				}
			});

		}else{
			window.codebird_auth = window.open('twitter_load.php', '','width=800,height=400,resizable=no,top='+100+',left='+($(document).width() / 2 - 400));

			$('.tricks__social').removeClass(ovclasses).addClass('wait');

			cb.__call(
			    "oauth_requestToken",
			    // {oauth_callback: "oob"},
			    function (reply,rate,err) {
			        if (err) {
			            // console.log("error response or timeout exceeded" + err.error);
			        }
			        if (reply) {
			        	// stores it
			            cb.setToken(reply.oauth_token, reply.oauth_token_secret);

			            // gets the authorize screen URL
			            cb.__call(
			                "oauth_authorize",
			                {},
			                function (auth_url) {
			                    window.codebird_auth.location.href = auth_url;
			                    document.getElementById("twitterpin").value = '';
			                    // console.log(selected, jsondata);
			                    var term;
			                    if (selected.term.indexOf('0')) {
			                    	term = parseInt(selected.term.replace('0', ''));
			                    }else{
			                    	term = parseInt(selected.term);
			                    }

			                    var termtext = jsondata.subtags[currentLang][term - 1];
			                    term = jsondata.tags[currentLang][term - 1];

			                    // console.log(termtext, term);
			                    // if (true) {};
			                    $('.tricks__social').removeClass(ovclasses).addClass('twitterpin');
			                }
			            );
			        }
			    }
			);
		}
	};

	$('.cancelTweet').on('click', function(){
		$('.tricks__social').removeClass(ovclasses);
		return false;
	});
	
	$('.checkpin').on('click', function(){
		// var pin = document.getElementById("twitterpin").value;

			$('.tricks__social').removeClass(ovclasses).addClass('posting');

		cb.__call(
		    "oauth_accessToken",
		    {oauth_verifier: tw_pin},
		    function (reply,rate,err) {
		            console.log(reply);
		        if (err) {
		            // console.log("error response or timeout exceeded" + err.error);
		            $('.tricks__social').removeClass(ovclasses);
		        }
		        if (reply) {
		            // store the authenticated token, which may be different from the request token (!)
		            localStorage.tw_token = reply.oauth_token;
		            localStorage.tw_token_secret = reply.oauth_token_secret;
		            cb.setToken(reply.oauth_token, reply.oauth_token_secret);
		            shareTwitter(true, $('#tweettext').val());
		        }

		        // if you need to persist the login after page reload,
		        // consider storing the token in a cookie or HTML5 local storage
		    }
		);
	

		

		return false;
	});

	var tw_pin = '';

	window.postTwitter = function(params) {
		// console.log(params);
		var token = (params.split('&')[0]).split('=')[1];
		tw_pin = (params.split('&')[1]).split('=')[1];



		// $('.tricks__social').removeClass(ovclasses).addClass('posting');

		// cb.__call(
		//     "oauth_accessToken",
		//     {oauth_verifier: pin},
		//     function (reply,rate,err) {
		//             console.log(reply);
		//         if (err) {
		//             // console.log("error response or timeout exceeded" + err.error);
		//             $('.tricks__social').removeClass(ovclasses);
		//         }
		//         if (reply) {
		//             // store the authenticated token, which may be different from the request token (!)
		//             localStorage.tw_token = reply.oauth_token;
		//             localStorage.tw_token_secret = reply.oauth_token_secret;
		//             cb.setToken(reply.oauth_token, reply.oauth_token_secret);
		//             shareTwitter(true, $('#tweettext').val());
		//             $('.tricks__social').removeClass(ovclasses);
		//         }

		//         // if you need to persist the login after page reload,
		//         // consider storing the token in a cookie or HTML5 local storage
		//     }
		// );


		return 'posted';
	};

	$('.checkpinFB').on('click', function(){
		$('.tricks__social').removeClass(ovclasses).addClass('wait');
		FB.login(function(response){
			if (response.authResponse) {
				var access_token = FB.getAuthResponse().accessToken;
				// console.log(access_token);
				postImage(access_token);
			}else{
				// console.log('User cancelled login or did not fully authorize.');
				$('.tricks__social').removeClass(ovclasses);
			}
		}, {scope: 'publish_actions,user_photos'});
	});

	function updateStatusCallback(data) {
		// console.log(data);
	}

	function scrollToSteps(){
		var top = $('.tricks__steps').offset().top;

		parent.postMessage("scrollto:"+ (top - 50), "*");
	}

	var currentLang = 'en';
	if (window.location.pathname == '/de') {
		currentLang = 'de';
	}
	if (window.location.pathname == '/fr') {
		currentLang = 'fr';
	}
	if (window.location.pathname == '/es') {
		currentLang = 'es';
	}
	if (window.location.pathname == '/it') {
		currentLang = 'it';
	}

	$('#tweettext, #fbtext').val(postStrings[currentLang]);

	var selected = {
		term: undefined,
		background: undefined,
		finalimage: undefined
	};

	var $gotostep1 = $('.tricks_button[gotostep="1"]');
	var $gotostep2 = $('.tricks_button[gotostep="2"]');
	var $gotostep3 = $('.tricks_button[gotostep="3"]');

	// step1
	var $selectedterm = $('.tricks__choose_term__term.tricks_active');
	$('.tricks__choose_term__term').on('click', function(){
		selected.term = $(this).attr('term-id');
		$selectedterm = $(this);
		$(this).addClass('tricks_active').siblings().removeClass('tricks_active');


		// $('.tricks__background_select__item').each(function(){
		// 	var bgid = $(this).attr('bg-id');
		// 	$(this).find('img').attr('src', '/assets/web/g_img/'+currentLang+'_'+selected.term+'_'+bgid+'_preview.jpg');
		// });

		track({
			cat: 'Your Style',
			act: 'selected style',
			val: selected.term
		});

		gotostep(1);
		scrollToSteps();
	});

	// step2
	var $selectedbackground = $('.tricks__background_select__item.tricks_active');
	$('.tricks__background_select__item').on('click', function(){
		selected.background = $(this).attr('bg-id');
		$selectedbackground = $(this);

		selected.finalimage = currentLang+'_'+selected.term+'_'+selected.background+'.jpg';

		$('.tricks__social__image img').attr('src', '/assets/web/g_img/'+selected.finalimage.replace('.jpg', '_thumb.jpg'));

		track({
			cat: 'Background',
			act: 'selected background',
			val: selected.background
		});

		gotostep(2);
		scrollToSteps();
		$(this).addClass('tricks_active').siblings().removeClass('tricks_active');
	});

	// step3


	$('.shareonfacebook').on('click', function(){
		shareFacebook();

		track({
			cat: 'Initiated Share',
			act: 'Initiated Facebook Share'
		});
		// }
		return false;
	});
	$('.shareontwitter').on('click', function(){

		shareTwitter();

		track({
			cat: 'Initiated Share',
			act: 'Initiated Twitter Share'
		});

		return false;
	});
	$('.downloadnow').on('click', function(){

		track({
			cat: 'Initiated Share',
			act: 'Downloaded'
		});

		window.location.replace('/download.php?img='+currentLang+','+selected.term+','+selected.background);

		return false;
	});

	// all steps
	var $steps = $('.tricks__content__step');
	var $steps_header = $('.tricks__steps li');

	var swiperis = 0;
	var mySwiper;
	function gotostep(step) {
			$steps.removeClass('tricks__content__step__visible').addClass('tricks__content__step__hidden');
			$($steps[step]).removeClass('tricks__content__step__hidden').addClass('tricks__content__step__visible');

			$($steps_header[step]).prevAll('li').addClass('tricks_active');
			$($steps_header[step]).addClass('tricks_active').nextAll('li').removeClass('tricks_active');
			setTimeout(function(){
				$steps.removeClass('tricks__content__step__hidden');
			},500);

			
			if (step === 1 && $(window).width() < 700) {
				$('.tricks__background_select').addClass('swiper-wrapper');
				mySwiper = new Swiper('.swiper-container', {
				    speed: 400,
				    spaceBetween: 0,
				    pagination: '.swiper-pagination'
				}); 
				// console.log($('.swiper-container'));
				swiperis = 1;
			}else{
				if (swiperis === 1) {
					setTimeout(function(){
						$('.tricks__background_select').removeClass('swiper-container');
						mySwiper.destroy(true, true);
						swiperis = 0;
					},100);
				}
			}

			// if (step === 0) {
			// 	$('.tricks__background_select__item img').attr('src', '');
			// }

			window.resizeFrame();
	}


			if ($(window).width() < 700) {
				$('.tricks__step__2').width($(window).width());
			}else{
				$('.tricks__step__2').width('auto');
			}
	var to = setTimeout(function(){},2);
	$(window).on('resize', function(){
		clearTimeout(to);
		to = setTimeout(function(){
			var ww = $(window).width();
			if (ww < 700) {
				$('.tricks__step__2').width(ww);
			}else{
				$('.tricks__step__2').width('auto');
			}
		},50);
	});

	$gotostep1.on('click', function(){
		scrollToSteps();
		gotostep(0);
		return false;
	});

	$gotostep2.on('click', function(){
		scrollToSteps();
		if (selected.term !== undefined) {
			gotostep(1);
		}
		return false;
	});

	$gotostep3.on('click', function(){
		scrollToSteps();
		if (selected.background !== undefined) {
			gotostep(2);	
		}
		return false;
	});


	// visual scroll
	$('.tricks__scrolldown').on('click', function(){
		scrollToSteps();
		return false;
	});

	$(document).on('click', '.tricks_active', function(){
		if (typeof $(this).attr('step') !== 'undefined') {
			var goto = parseInt($(this).attr('step'));
			scrollToSteps();
			gotostep(goto);
		}
	});


	gotostep(0);
});

